/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Conditional,
  Text,
  Space,
  Paper,
} from '@cashfree-intl/coherent';
import { copyToClipboard } from 'utils/common';
import CustomIcon from 'components/CustomIcons';
import {
  StyledCopyToClipboard,
  StyledDetailsContainer,
  StyledDetailsObject,
  StyledDisplayText,
  StyledOpenNewTab,
} from '../styled';
import { DETAILS_DISPLAY_TEXT_MAPPING } from '../constants';
import { INDIVIDUAL } from '../../Vendors/constants';

function VendorKycDetails({
  vendorDeleted,
  kycDetailsObj,
  kycDocumentsObj,
  onEditClickHandler,
  onFilePreviewClickHandler,
  filePreviewMapping,
  nbfc,
}) {
  const displayDocs = obj => {
    if (kycDocumentsObj[obj] && kycDocumentsObj[obj].length) {
      return (
        <Space direction="column" gap={1}>
          <Space
            gap={1}
            alignItems="center"
            onClick={() =>
              onFilePreviewClickHandler(
                filePreviewMapping[kycDocumentsObj[obj][0]],
              )
            }
            data-event-name="Form_VendorKycDetails_Icon_File"
            data-ignore-inner-text="true"
          >
            <Space gap={1} alignItems="center">
              <div>
                <CustomIcon
                  componentName="FILE_FORMAT"
                  width="14"
                  height="16"
                />
              </div>
              <Text variant="b14" color="primary">
                {kycDocumentsObj[obj][0].substring(0, 13)}...
              </Text>
            </Space>
            <StyledOpenNewTab>
              <CustomIcon componentName="OPEN_NEW_TAB" />
            </StyledOpenNewTab>
          </Space>
          {kycDocumentsObj[obj].length === 2 ? (
            <Space
              gap={1}
              alignItems="center"
              onClick={() =>
                onFilePreviewClickHandler(
                  filePreviewMapping[kycDocumentsObj[obj][1]],
                )
              }
              data-event-name="Form_VendorKycDetails_Icon_File"
              data-ignore-inner-text="true"
            >
              <div>
                <CustomIcon
                  componentName="FILE_FORMAT"
                  width="14"
                  height="16"
                />
              </div>
              <Text variant="b14" color="primary">
                {kycDocumentsObj[obj][1].substring(0, 13)}...
              </Text>
              <StyledOpenNewTab>
                <CustomIcon componentName="OPEN_NEW_TAB" />
              </StyledOpenNewTab>
            </Space>
          ) : null}
        </Space>
      );
    }
  };

  return (
    <Paper>
      <Space direction="column">
        <Space justifyContent="space-between" alignItems="center">
          <Text variant="h16" strong className="mb-4">
            KYC Details
          </Text>
          <Conditional if={!vendorDeleted}>
            <Button
              secondary
              size="small"
              onClick={() => onEditClickHandler('kycDetails')}
              data-event-name="Form_VendorKycDetails_Button_Edit"
            >
              <CustomIcon componentName="EDIT" className="mr-1" />
              Edit
            </Button>
          </Conditional>
        </Space>
        <StyledDetailsContainer>
          {Object.keys(kycDetailsObj).map(obj => {
            let panDisplay = '';
            if (kycDetailsObj[obj] !== '') {
              if (obj === 'pan') {
                panDisplay =
                  kycDetailsObj.accountType === INDIVIDUAL
                    ? 'PAN & Document'
                    : 'Business PAN & Document';
                return (
                  <StyledDetailsObject gap={5} className="mb-2">
                    <StyledDisplayText variant="b14" color="bodyLight">
                      {panDisplay}
                    </StyledDisplayText>
                    <Space direction="column" gap={1}>
                      <Text variant="b14">{kycDetailsObj[obj]}</Text>
                      {kycDocumentsObj[obj].length > 0 && (
                        <Space
                          gap={1}
                          data-testid={`file-preview-${
                            filePreviewMapping[kycDocumentsObj[obj][0]]
                          }`}
                          alignItems="center"
                          onClick={() =>
                            onFilePreviewClickHandler(
                              filePreviewMapping[kycDocumentsObj[obj][0]],
                            )
                          }
                          data-event-name="Form_VendorKycDetails_Icon_File"
                          data-ignore-inner-text="true"
                        >
                          <div>
                            <CustomIcon
                              componentName="FILE_FORMAT"
                              width="14"
                              height="16"
                            />
                          </div>
                          <Text color="primary">
                            {kycDocumentsObj[obj][0].substring(0, 13)}...
                          </Text>
                          <StyledOpenNewTab>
                            <CustomIcon componentName="OPEN_NEW_TAB" />
                          </StyledOpenNewTab>
                        </Space>
                      )}
                    </Space>
                  </StyledDetailsObject>
                );
              }
              return (
                <StyledDetailsObject gap={5} className="mb-2">
                  <StyledDisplayText variant="b14" color="bodyLight">
                    {DETAILS_DISPLAY_TEXT_MAPPING[obj]}
                  </StyledDisplayText>
                  <Space direction="column" gap={1}>
                    <Space gap={1} alignItems="center">
                      <Text variant="b14">{kycDetailsObj[obj]}</Text>
                      {obj === 'accountType' && (
                        <StyledCopyToClipboard>
                          <CustomIcon
                            componentName="COPY_TO_CLIPBOARD"
                            handleClick={copyToClipboard(kycDetailsObj[obj])}
                          />
                        </StyledCopyToClipboard>
                      )}
                    </Space>
                    {displayDocs(obj)}
                  </Space>
                </StyledDetailsObject>
              );
            }
          })}
          <Conditional if={nbfc && nbfc.docValue}>
            <StyledDetailsObject gap={5} className="mb-2">
              <StyledDisplayText variant="b14" color="bodyLight">
                NBFC Document
              </StyledDisplayText>
              <Space direction="column" gap={1}>
                <Space
                  gap={1}
                  alignItems="center"
                  onClick={() =>
                    onFilePreviewClickHandler(filePreviewMapping[nbfc.docValue])
                  }
                  data-event-name="Form_VendorKycDetails_Icon_File"
                  data-ignore-inner-text="true"
                >
                  <div>
                    <CustomIcon
                      componentName="FILE_FORMAT"
                      width="14"
                      height="16"
                    />
                  </div>
                  <Text color="primary">
                    {nbfc?.docValue.substring(0, 13)}...
                  </Text>
                  <StyledOpenNewTab>
                    <CustomIcon componentName="OPEN_NEW_TAB" />
                  </StyledOpenNewTab>
                </Space>
              </Space>
            </StyledDetailsObject>
          </Conditional>
        </StyledDetailsContainer>
      </Space>
    </Paper>
  );
}

VendorKycDetails.propTypes = {
  vendorDeleted: PropTypes.bool.isRequired,
  kycDetailsObj: PropTypes.object.isRequired,
  kycDocumentsObj: PropTypes.object.isRequired,
  onEditClickHandler: PropTypes.func.isRequired,
  onFilePreviewClickHandler: PropTypes.func.isRequired,
  nbfc: PropTypes.object,
  filePreviewMapping: PropTypes.object.isRequired,
};

export default VendorKycDetails;
